import { Col, Form, Input, Select, Button, Modal, Table } from 'antd';
import { useContext, useState } from 'react';
import { PageContext } from '../../../lib/context';

const AdditionalFeesForm = () => {
  const {
    addFees,
    additional_fee_form,
    _onFinishFees,
    _additionalFeesSubmit,
    showFees,
    setShowFees,
    subFeecolumns,
    addFeesTable,
  } = useContext(PageContext);

  type RequiredMark = boolean | 'optional';
  const [requiredMark] = useState<RequiredMark>('optional');

  return (
    <div>
      <Button
        className="flex flex-col place-items-center"
        onClick={() => {
          setShowFees(true);
        }}
      >
        Add Fees
      </Button>
      <Modal
        title="Add Fees"
        visible={showFees}
        closable
        onCancel={() => setShowFees(false)}
        footer={
          <div>
            <Button type="primary" onClick={_additionalFeesSubmit}>
              Submit
            </Button>
          </div>
        }
      >
        <div style={{ textAlign: 'left' }}>
          <Form
            form={additional_fee_form}
            onFinish={_onFinishFees}
            layout="vertical"
            requiredMark={requiredMark}
          >
            <Col span={24}>
              <Form.Item
                label="Please Select Fee"
                name="additional_fees_id"
                rules={[
                  { required: true, message: 'Additional fee is required' },
                ]}
              >
                <Select
                  showSearch
                  filterOption={(input: any, option: any) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {addFees.map(({ id, title }: any) => (
                    <Select.Option key={`${id}`} value={id}>
                      {title}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item label="Notes" name="notes">
                <Input.TextArea rows={7} />
              </Form.Item>
            </Col>
            <Form.Item name="subscriber_id" hidden>
              <Input />
            </Form.Item>
          </Form>
        </div>
      </Modal>

      <div className="flex flex-row mt-10">
        <div className="w-full mr-3">
          <Table dataSource={addFeesTable} columns={subFeecolumns} bordered />
        </div>
      </div>
    </div>
  );
};

export default AdditionalFeesForm;
